import { useCallback } from 'react';

import { alignChannelWithBackend, getChannelPerformanceLabel } from 'src/data/channel';
import { queryIntegrationAuthorizationRequestInfo } from 'src/graphql/performance';
import { ChannelAuthError } from 'src/lib/errors';
import { openAuthorizeIntegrationPopup } from 'src/lib/oauth';
import { useCurrentCustomerId, usePerformanceActions } from 'src/store';

export const useAuthorizeIntegration = () => {
  const performanceActions = usePerformanceActions();
  const currentCustomerId = useCurrentCustomerId();

  return useCallback(
    async (channel, options) => {
      // Get initial authorization info for this "channel" from BE
      const dataSource = alignChannelWithBackend(channel);
      const result = await queryIntegrationAuthorizationRequestInfo(dataSource, currentCustomerId);
      if (result.type !== 'link') {
        throw new ChannelAuthError(
          `Error getting ${getChannelPerformanceLabel(channel)} authorization code`
        );
      }

      // Request user to proceed with authorization
      const authData = await openAuthorizeIntegrationPopup(result.url);
      if (!authData) {
        throw new ChannelAuthError(
          `Error getting ${getChannelPerformanceLabel(channel)} authorization code`
        );
      }
      if (!authData.code) {
        throw new ChannelAuthError(
          `Error in ${getChannelPerformanceLabel(channel)} Authorization: No auth code`
        );
      }

      // Provide received auth token and complete authorization process on BE
      return performanceActions.integrationAuthorize(
        channel,
        {
          authorizationCode: authData.code,
        },
        options
      );
    },
    [performanceActions, currentCustomerId]
  );
};
